module.exports = __webpack_public_path__ + "static/media/mars-stroke-v.89f677c2.svg";